import * as React from 'react';

var _path, _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgUsdc = function SvgUsdc(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_66_24923",
        width: 80,
        height: 80,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#D9D9D9",
        d: "M0 0h80v80H0z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_66_24923)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_66_24923)",
        fillOpacity: 0.16,
        d: "M32.365 71.631Q37.808 74.001 44 74q6.211 0 11.686-2.369t9.526-6.461 6.42-9.535T74 44q0-6.211-2.369-11.686-2.368-5.475-6.42-9.526-4.05-4.05-9.525-6.42Q50.21 14.002 44 14q-6.192 0-11.635 2.369t-9.535 6.42q-4.092 4.05-6.461 9.525T14 44q0 6.192 2.369 11.635t6.461 9.535 9.535 6.461"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_66_24923)",
        d: "M38.545 62.314h2.724v-4.013q3.995-.135 7.212-2.452 3.218-2.317 3.218-6.823 0-3.866-2.32-6.212-2.321-2.346-8.2-4.635-5.474-2.064-7.128-3.583t-1.654-4.314q0-2.712 2.164-4.532 2.163-1.82 5.606-1.82 2.499 0 4.333 1.102 1.833 1.102 3.147 3.051l2.27-1.019q-1.417-2.403-3.622-3.814a10.36 10.36 0 0 0-4.86-1.615v-3.93h-2.724v3.93q-4.377.583-6.676 3.028-2.298 2.446-2.298 5.62 0 3.698 2.34 5.858t7.788 4.244q5.52 2.205 7.379 3.952t1.859 4.689q0 3.5-2.657 5.189t-5.927 1.689q-3.057 0-5.567-1.705t-3.894-4.744l-2.391.968q1.685 3.321 4.131 5.112 2.445 1.792 5.747 2.6zM40 70q-6.192 0-11.635-2.369T18.83 61.17t-6.461-9.535Q9.999 46.192 10 40q0-6.211 2.369-11.686t6.461-9.526 9.535-6.42Q33.808 10.002 40 10q6.211 0 11.686 2.369t9.526 6.42q4.05 4.05 6.42 9.525Q70 33.79 70 40q0 6.192-2.369 11.635-2.368 5.442-6.42 9.535-4.05 4.092-9.525 6.461T40 70m0-2.564q11.449 0 19.442-8.003T67.436 40q0-11.448-7.994-19.442T40 12.564q-11.43 0-19.433 7.994T12.564 40q0 11.43 8.003 19.433T40 67.436"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_66_24923",
        x1: 14.627,
        x2: 73.165,
        y1: 44,
        y2: 44,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_66_24923",
        x1: 10.627,
        x2: 69.165,
        y1: 40,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgUsdc as ReactComponent };
//# sourceMappingURL=USDC.svg.es.js.map
